// src/pages/EventCard.tsx

import React from 'react';
import moment from 'moment'; // 날짜 처리를 위해 moment.js 라이브러리 사용
import { NavLink } from 'react-router-dom';

interface EventCardProps {
  id: string; // 이벤트 ID를 추가
  imageUrl: string;
  title: string;
  startDate: string;
  endDate: string;
  rewardStartDate?: string; // 보상 수령 시작 날짜, 선택적 속성 추가
  rewardEndDate?: string; // 보상 수령 종료 날짜, 선택적 속성
  isNew: boolean;
}

const EventCard: React.FC<EventCardProps> = ({
  id,
  imageUrl,
  title,
  startDate,
  endDate,
  rewardStartDate, // 추가
  rewardEndDate,
  isNew,
}) => {
  const formatDate = (dateString: string) => {
    return moment(dateString).format('YYYY-MM-DD');
  };

  return (
    <div className="relative bg-white rounded-lg shadow-lg overflow-hidden">
      <NavLink to={`/event/${id}`}>
        {isNew && (
          <span className="absolute top-0 left-0 bg-red-500 text-white py-1 px-3 text-xs Pretendard-Bold">
            NEW
          </span>
        )}
        <img src={imageUrl} alt={title} className="w-full h-60 mobile:h-[164px] object-fill" />
        <div className="p-4">
          <div className="flex items-center w-full">
            <h3 className="text-lg mobile:text-base Pretendard-Bold tracking-wide truncate text-ellipsis w-[350px] text-nowrap">{title}</h3>
            <p className="ml-auto  Pretendard-Regular text-sm text-nowrap mobile:text-[11px]">
              {isOngoing(startDate, endDate)
                ? '진행 중'
                : isEnded(endDate)
                ? '종료'
                : '진행 예정'}
            </p>
          </div>

          <p className="Pretendard-Regular text-sm mobile:text-xs text-black/50 tracking-wide mt-2">
            이벤트 기간 &nbsp;|&nbsp; {formatDate(startDate)} - {formatDate(endDate)}
          </p>

          {rewardStartDate && rewardEndDate && (
            <p className="Pretendard-Regular text-sm mobile:text-xs text-black/50 tracking-wide mt-[2px]">
              보상 수령 기간 &nbsp;|&nbsp; {formatDate(rewardStartDate)} -{' '}
              {formatDate(rewardEndDate)}
            </p>
          )}
        </div>
      </NavLink>
    </div>
  );
};

// 이벤트 진행 상태 확인 함수
const isOngoing = (startDate: string, endDate: string) => {
  const now = moment();
  return now.isBetween(moment(startDate), moment(endDate), undefined, '[]'); // 시작일과 종료일 포함
};

// 이벤트 종료 여부 확인 함수
const isEnded = (endDate: string) => {
  const now = moment();
  return now.isAfter(moment(endDate));
};

export default EventCard;
